import {isEmptyValue} from '../../utils'

export function isEmptyFilterValue(value) {
  if (Array.isArray(value)) {
    return !value.length
  }
  return isEmptyValue(value)
}
